import { Button, message, Popconfirm } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ButtonProps } from 'antd/es/button';
import { tradeAcceptOfferV1 } from 'services/api/return';
import { getApiErrorCodeMsg } from 'services/api/utils/errorCode';

/** 等待退货; */
const WaitReturn = (
  props: Omit<ButtonProps, 'onClick'> & {
    platform?: General.PlatformUpperCase;
    onSucceed?: () => void;
    returnSn: string;
  },
) => {
  const { platform, returnSn, onSucceed, disabled, ...restProps } = props;
  const { t } = useTranslate();

  if (platform === 'SHOPEE' && returnSn) {
    return (
      <Popconfirm
        disabled={disabled}
        title={t('ViewRefund.确认等待买家退货吗')}
        onConfirm={() => {
          tradeAcceptOfferV1({
            returnExternalId: returnSn,
            operate: 'WAIT_RETURN',
          })
            .then(() => {
              if (onSucceed) {
                onSucceed();
              }
            })
            .catch((e) => {
              message.error(getApiErrorCodeMsg(e.response));
            });
        }}
      >
        <Button size="small" disabled={disabled} {...restProps}>
          {t('trade.等待退货')}
        </Button>
      </Popconfirm>
    );
  }

  return (
    <Button size="small" title={t('trade.暂不支持操作提示')} disabled {...restProps}>
      {t('trade.等待退货')}
    </Button>
  );
};

export default WaitReturn;
